<div class="breadcrumb-menu d-flex negative-margin-right">
  <!-- region BREADCRUMB MENU ELEMENTS -->
  <ng-content></ng-content>
  <!-- endregion BREADCRUMB MENU ELEMENTS -->
</div>
